// removed by extract-text-webpack-plugin
module.exports = {"preference-switch":"PreferenceSwitch__preference-switch___kyLwx"};